import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var genHash = function genHash() {
  return "".concat(Math.random().toString().substring(2, 12));
};
export var useClientId = function useClientId() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var _useState = useState(genHash),
    _useState2 = _slicedToArray(_useState, 1),
    pseudoHash = _useState2[0];
  return "".concat(name, "-").concat(pseudoHash);
};
export var useHighlyFlamableUnsafeHackyIdCrutch = function useHighlyFlamableUnsafeHackyIdCrutch() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var _useState3 = useState(genHash),
    _useState4 = _slicedToArray(_useState3, 2),
    pseudoHash = _useState4[0],
    setHash = _useState4[1];
  useEffect(function () {
    /**
     * Делаем перерендер с новым ID, чтобы вправить мозг react'у
     * По факту этот перерендер не нужен, но без него virtual-dom будет рассинхронизирован с реальным
     */
    setHash(genHash());
  }, []);
  return "".concat(name, "-").concat(pseudoHash);
};